

//******************** persist actions***************//
export function setPersistActions(e:any){

    return{
        type: "SET_PersistActions",
        payload:e,
    }
}